export default __webpack_public_path__ + "static/media/Ordenamiento_Departamental.ddfe3302.jpg";